import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { CreateClientContractTermForm } from '~/features/CreateClientContractTermForm';
import styles from './index.module.scss';

/**
 * 企業契約期間 新規作成 Screen
 *
 * - PageHeader は API 発火しないため Screen で直接表示（Feature 化不要）
 * - パンくず: 企業契約期間 > 新規作成
 */
export const Screen: React.FC = () => (
  <>
    <PageHeader
      variant='breadcrumb'
      breadcrumbItems={[
        { label: '企業契約期間', href: '/client-contracts' },
        { label: '新規作成' },
      ]}
    />
    <main className={styles.body}>
      <Suspense fallback={<Loader />}>
        <CreateClientContractTermForm />
      </Suspense>
    </main>
  </>
);
